// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalVideo_wrapper__3TKxs","show":"ModalVideo_show__3FVME","modal":"ModalVideo_modal__3dvJU"};